export default "__VITE_ASSET__1d28a0b6__"